const CAMPO_ANEXO = 'anexos';

export function aplicarCamposAndamento(
  form: FormData,
  input: { clientRequestId: string; modeloAndamentoId?: string },
): void {
  form.append('clientRequestId', input.clientRequestId);
  if (input.modeloAndamentoId) form.append('modeloAndamentoId', input.modeloAndamentoId);
}

export function anexarArquivosAndamento(form: FormData, arquivos: File[]): void {
  for (const arquivo of arquivos) form.append(CAMPO_ANEXO, arquivo);
}
